import StockTrackerImg from "../assets/projects_images/stock tracker.PNG";
import SortingVisulizerImg from "../assets/projects_images/sorting visulizer.PNG";
import netflix from "../assets/projects_images/netflix.PNG";
import infyVerse from "../assets/projects_images/infyverse0.png";
import swagLab from "../assets/projects_images/swaglab.PNG";
import tictoker from '../assets/projects_images/tictoker.PNG';
import insta from '../assets/projects_images/insta.PNG';
import webcheckmate from "../assets/projects_images/webcheckmate.PNG";
import rise_award_fy23_q2 from "../assets/certifications/Achievements/RISE Award.jpeg"
import rise_award_fy24_q3 from "../assets/certifications/Achievements/Rise Award FY24 Q3.png"
import insta_award from "../assets/certifications/Achievements/INSTA award.jpeg"
import lexathon from "../assets/certifications/Achievements/Lexathon.jpeg"
import MMAI_hackathon from "../assets/certifications/Achievements/MMAI_hackathon.jpg"
import notenest from "../assets/projects_images/notenest.PNG"
import excelsheetio from "../assets/projects_images/Excel_Python1.png"
import milligram from "../assets/projects_images/milligram_w.jpg"
import reactjs_professional from "../assets/certifications/FullStackProfesional/Infosys Certified React Professional.jpg"
import nodejs_professional from "../assets/certifications/FullStackProfesional/Infosys Certified NodeJS Professional.jpg"
import mongodb_professional from "../assets/certifications/FullStackProfesional/Infosys Certified Mongo Developer.jpg"
import javaSe8 from "../assets/certifications/SDET Foundation/Infosys Certified Java SE8 Developer_page-0001.jpg"
import java from "../assets/certifications/SDET Foundation/Infosys Certified Java Programmer_page-0001.jpg"
import pythonAssociate from "../assets/certifications/SDET Foundation/Infosys Certified Python Associate_page-0001.jpg"
import pythonProgrammer from "../assets/certifications/SDET Foundation/Infosys Certified Python Programmer_page-0001.jpg"
import seleniumBasic from "../assets/certifications/SDET Foundation/Infosys Certified Selenium Basic Automation Tester_page-0001.jpg"
import databaseSQL from "../assets/certifications/SDET Foundation/Infosys Certified Database and SQL Professional_page-0001.jpg"
import devOps from "../assets/certifications/SDET Foundation/Infosys Certified DevOps Professional_page-0001.jpg"
import dataManagementAssociate from "../assets/certifications/SDET Foundation/Infosys Certified Data Management Associate_page-0001.jpg"
import awsAssociatePractitioner from "../assets/certifications/SDET Advance/Infosys Certified AWS Associate Practitioner_page-0001.jpg"
import awsSolutionArchitech from "../assets/certifications/SDET Advance/Infosys Certified AWS Solutions Architect Associate_page-0001.jpg"
import databaseSQLAdvance from "../assets/certifications/SDET Advance/Infosys Certified Advance Database and SQL Professional_page-0001.jpg"
import BDDCucumber from "../assets/certifications/SDET Advance/Infosys Certified BDD Cucumber Automation Tester_page-0001.jpg"
import RestAPI from "../assets/certifications/SDET Advance/Infosys Certified Rest Assured Tester_page-0001.jpg"
import seleniumAdvance from "../assets/certifications/SDET Advance/Infosys Certified Selenium Advance Automation Tester_page-0001.jpg"
import docker from "../assets/certifications/SDET Advance/Infosys Certified Selenium Grid with Docker Testing Professional_page-0001.jpg"

// project data
const data = [
    {
        title: 'Milligram Connect',
        image_url: milligram,
        desc: 'Social media application.',
        type: ['mobility', 'fullstack', 'priority'],
        tech_stacks: ['react native', 'firebase', 'firestore', 'firebase authentication', 'css'],
        project_url: 'https://drive.google.com/drive/folders/1pk66rxazQqvdj0GTJ2Mdsm78N9W1JKBb',
        project_documentation: 'https://dev.to/soumyajit7/milligram-connect-social-media-application-57gn',
    },
    {
        title: 'Tic-Tac-Toe Multiplayer',
        image_url: tictoker,
        desc: 'A multiplayer game, user can play and chatting.',
        type: ['fullstack', 'priority'],
        tech_stacks: ['react', 'firebase', 'firestore', 'firebase authentication', 'css'],
        project_url: 'https://tictactoe-multiplayer29.netlify.app',
        project_documentation: 'https://dev.to/soumyajit7/tic-tac-toe-multiplayer-game-2k9i',
    },
    {
        title: 'Stock Tracker',
        image_url: StockTrackerImg,
        desc: 'A web app to track the real-time stock market data',
        type: ['frontend'],
        tech_stacks: ['react', 'firebase', 'firestore', 'firebase authentication', 'css'],
        project_url: 'https://stocktracker0.netlify.app/',
        project_documentation: 'https://dev.to/soumyajit7/stock-tracker-a-web-app-to-track-the-real-time-stock-market-data--jo3',
    },
    {
        title: 'Sorting Visulizer',
        image_url: SortingVisulizerImg,
        desc: 'A web app to visualize sorting algorithm.',
        type: ['frontend', 'priority'],
        tech_stacks: ['react', 'firebase', 'firestore', 'firebase authentication', 'css'],
        project_url: 'https://sorting-visualizer-29.netlify.app/',
        project_documentation: 'https://dev.to/soumyajit7/sorting-visualizer-a-web-app-to-visualize-sorting-algorithm--2eni',
    },
    {
        title: 'ExcelSheetIO',
        image_url: excelsheetio,
        desc: 'Python Package For Excel Sheet Operations',
        type: ['backend', 'priority'],
        tech_stacks: ['python', 'pandas'],
        project_url: 'https://pypi.org/project/ExcelSheetIO/',
        project_documentation: 'https://pypi.org/project/ExcelSheetIO/',
    },
    {
        title: 'Instagram Clone',
        image_url: insta,
        desc: 'Social Media App',
        type: ['fullstack'],
        tech_stacks: ['react', 'firebase', 'firestore', 'firebase authentication', 'css', 'vercel'],
        project_url: 'https://instagram-soumyajitpan.vercel.app/',
        project_documentation: 'https://dev.to/soumyajit7/instagram-clone-live-app-3dbm',
    },
    {
        title: 'Netflix UI Clone',
        image_url: netflix,
        desc: 'Netflix Official site UI clone.',
        type: ['frontend'],
        tech_stacks: ['react', 'css', 'vercel'],
        project_url: 'https://netflix-clone-soumyajitpan.vercel.app',
        project_documentation: 'https://dev.to/soumyajit7/netflix-ui-clone-6bf',
    },
    {
        title: 'Infy-Verse',
        image_url: infyVerse,
        desc: 'All in one webapp Mailling + Chatting + Meeting + Calender.',
        type: ['fullstack'],
        tech_stacks: ['react', 'firebase', 'firestore', 'firebase authentication', 'css'],
        project_url: 'https://infy-verse.netlify.app/',
        project_documentation: 'https://dev.to/soumyajit7/infy-verse-a-all-in-one-platform-for-mailchatmeetingcalender-4j54',
    },
    {
        title: 'Web-Check-Mate',
        image_url: webcheckmate,
        desc: 'Web apps for automation testing.',
        type: ['frontend', 'automation'],
        tech_stacks: ['react', 'css'],
        project_url: 'https://webcheckmate.netlify.app/',
        project_documentation: '',
    },
    {
        title: 'Swag Lab Testing',
        image_url: swagLab,
        desc: 'Automation testing using selenium with Java.',
        type: ['automation'],
        tech_stacks: ['java', "selenium"],
        project_url: 'https://youtu.be/x2DzI_NE9p0',
        project_documentation: '',
    },
    {
        title: 'NoteNest',
        image_url: notenest,
        desc: 'Note Saving Application',
        type: ['fullstack'],
        tech_stacks: ['react', 'express', 'mongodb', 'vercel', 'css', 'auth0'],
        project_url: 'https://notenest00.netlify.app/',
        project_documentation: '',
    },
]
// data.sort((a, b) => b.key - a.key);
export default data;
export const leetCodeCount = 1050;
export const codeshefRankCount = 74399;
export const projectsCount = data.length;
const startDate = new Date(2021, 1); // February 2021
const currentDate = new Date();
export const yearsOfExperienceCount = Math.floor((currentDate - startDate) / (1000 * 60 * 60 * 24 * 365));
export const linkedinId = "https://www.linkedin.com/in/soumyajit-pan-29-som/";
export const twitterId = "https://twitter.com/iamsoumyajitpan";
export const telegramId = "https://t.me/iamsoumyajitpan";

export const lang = [
    {
        key: 1,
        language: 'C',
    },
    {
        key: 2,
        language: 'C++',
    },
    {
        key: 3,
        language: 'Python',
    },
    {
        key: 4,
        language: 'Java',
    },
    {
        key: 5,
        language: 'JavaScript',
    },
    {
        key: 6,
        language: 'Dart',
    },
    {
        key: 7,
        language: 'HTML',
    },
    {
        key: 8,
        language: 'CSS',
    }
]

export const frameworks = [
    {
        key: 1,
        language: 'ReactJs',
    },
    {
        key: 2,
        language: 'React Native',
    },
    {
        key: 3,
        language: 'NodeJs',
    },
    {
        key: 4,
        language: 'Pandas',
    },
    {
        key: 5,
        language: 'Selenium',
    },
    {
        key: 6,
        language: 'Robot',
    },
    {
        key: 7,
        language: 'Cucumber',
    }
]

export const databases = [
    {
        key: 1,
        language: 'MySQL',
    },
    {
        key: 2,
        language: 'SQL',
    },
    {
        key: 3,
        language: 'PgSQL',
    },
    {
        key: 4,
        language: 'MongoDB',
    },
    {
        key: 5,
        language: 'FireStore',
    },
    {
        key: 6,
        language: 'BigQuery',
    }
]

export const tools = [
    {
        key: 1,
        language: 'Github',
    },
    {
        key: 2,
        language: 'Postman',
    },
    {
        key: 4,
        language: 'Firebase',
    },
    {
        key: 5,
        language: 'Netlify',
    },
    {
        key: 3,
        language: 'Google Cloud',
    },
    {
        key: 6,
        language: 'Gemini AI',
    },
    {
        key: 7,
        language: 'Jira',
    }
]

export const experiences = [
    {
        key: 1,
        company: "Infosys",
        role: "System Engineer",
        startTime: "Sept, 2021",
        endTime: "Present",
        total_time: "2 Years",
        place: "Hyderabad, India",
        workDetails: "Developed responsive web applications with React.js, Redux, and React Hooks, enhancing user engagement by 20-25%, improving performance by 10-15% through optimization techniques, integrating Gemini AI for advanced analytics, and ensuring business logic accuracy through test automation with Selenium and Robot Framework. Tech Stack: React.js, Redux, React Hooks, CSS, Gemini AI, GCP, Selenium, Robot, Python.",
    },
    {
        key: 2,
        company: "CSM Technologies",
        role: "Python Trainee Engineer",
        startTime: "Feb, 2021",
        endTime: "Sept, 2021",
        total_time: "7 Months",
        place: "Bhubanesswar, India",
        workDetails: "Collaborated on developing and updating features for 'Kwantify' portal using Python Odoo framework, HTML, and CSS.",
    }
]

export const educations = [
    {
        key: 1,
        college: "Gandhi Institute For Technology",
        course: "Bachelor of Technology",
        branch: "Electronics & Communication Engineering",
        time: "July, 2017 - May, 2021",
        total_time: "4 Years",
        place: "Bhubanesswar, Odisha, India",
    },
]

export const achievements = [
    {
        key: 1,
        achievement_image: rise_award_fy23_q2,
        award_title: "Rise Award, Q2 2023",
        achievement_description: 'For exceptional performance and best team',
    },
    {
        key: 2,
        achievement_image: insta_award,
        award_title: "Insta Award",
        achievement_description: 'For reskilled on SDET foundation and SDET advanced in a short period of time',
    },
    {
        key: 3,
        achievement_image: lexathon,
        award_title: "Hackathon - Lexathon",
        achievement_description: 'Ranked 9th in Infosys Hackathon.',
    },
    {
        key: 4,
        achievement_image: rise_award_fy24_q3,
        award_title: "Rise Award, Q3 2024",
        achievement_description: 'For exceptional performance and best team',
    },
    {
        key: 5,
        achievement_image: MMAI_hackathon,
        award_title: "Hackathon - Misson Modernization with AI",
        achievement_description: 'Ranked 2nd in Infosys Hackathon.',
    }
].reverse()

export const fullStackProfessional = [
    {
        key: 1,
        achievement_image: reactjs_professional,
        achievement_description: 'React.JS Professional',
    },
    {
        key: 2,
        achievement_image: nodejs_professional,
        achievement_description: 'Node.JS Professional',
    },
    {
        key: 3,
        achievement_image: mongodb_professional,
        achievement_description: 'MongoDB Professional',
    }
]

export const SDET_Foundation = [
    {
        key: 1,
        achievement_image: javaSe8,
        achievement_description: 'Java SE8 Developer',
    },
    {
        key: 2,
        achievement_image: java,
        achievement_description: 'Java Programmer',
    },
    {
        key: 3,
        achievement_image: pythonAssociate,
        achievement_description: 'Python Associate',
    },
    {
        key: 4,
        achievement_image: pythonProgrammer,
        achievement_description: 'Python Programmer',
    },
    {
        key: 5,
        achievement_image: seleniumBasic,
        achievement_description: 'Selenium Basic',
    },
    {
        key: 6,
        achievement_image: databaseSQL,
        achievement_description: 'Database SQL',
    },
    {
        key: 7,
        achievement_image: devOps,
        achievement_description: 'DevOps',
    },
    {
        key: 8,
        achievement_image: dataManagementAssociate,
        achievement_description: 'Data Management Associate',
    }
]

export const SDET_Advance = [
    {
        key: 1,
        achievement_image: awsAssociatePractitioner,
        achievement_description: 'AWS Associate Practitioner',
    },
    {
        key: 2,
        achievement_image: awsSolutionArchitech,
        achievement_description: 'AWS Solution Architech',
    },
    {
        key: 3,
        achievement_image: databaseSQLAdvance,
        achievement_description: 'Database SQL Advance',
    },
    {
        key: 4,
        achievement_image: BDDCucumber,
        achievement_description: 'BDD Cucumber',
    },
    {
        key: 5,
        achievement_image: RestAPI,
        achievement_description: 'Rest API',
    },
    {
        key: 6,
        achievement_image: seleniumAdvance,
        achievement_description: 'Selenium Advance',
    },
    {
        key: 7,
        achievement_image: docker,
        achievement_description: 'Docker',
    }
]

export const tech_stacks_logos = {
    "d3": "https://img.shields.io/badge/d3-%23F9A03C.svg?style=flat-square&logo=d3.js&logoColor=white",
    "javascript": "https://img.shields.io/badge/javascript-%23323330.svg?style=flat-square&logo=javascript&logoColor=%23F7DF1E",
    "chakra ui": "https://img.shields.io/badge/Chakra_UI-%233197C6.svg?style=flat-square&logo=chakra-ui&logoColor=white",
    "react": "https://img.shields.io/badge/react-%2320232a.svg?style=flat-square&logo=react&logoColor=%2361DAFB",
    "flask": "https://img.shields.io/badge/flask-%23000.svg?style=flat-square&logo=flask&logoColor=white",
    "azure": "https://img.shields.io/badge/azure-%230072C6.svg?style=flat-square&logo=azure-devops&logoColor=white",
    "postgre": "https://img.shields.io/badge/PostgreSQL-%23336791.svg?style=flat-square&logo=postgresql&logoColor=white",
    "express": "https://img.shields.io/badge/Express.js-%23404d59.svg?style=flat-square",
    "mongodb": "https://img.shields.io/badge/MongoDB-%234ea94b.svg?style=flat-square&logo=mongodb&logoColor=white",
    "docker": "https://img.shields.io/badge/docker-%230db7ed.svg?style=flat-square&logo=docker&logoColor=white",
    "aws": "https://img.shields.io/badge/AWS-%23FF9900.svg?style=flat-square&logo=amazon-aws&logoColor=white",
    "next.js": "https://img.shields.io/badge/next.js-%23000000.svg?style=flat-square&logo=nextdotjs&logoColor=white",
    "tailwind css": "https://img.shields.io/badge/tailwindcss-%2338B2AC.svg?style=flat-square&logo=tailwind-css&logoColor=white",
    "vercel": "https://img.shields.io/badge/vercel-%23000000.svg?style=flat-square&logo=vercel&logoColor=white",
    "tensorflow": "https://img.shields.io/badge/TensorFlow-%23FF6F00.svg?style=flat-square&logo=TensorFlow&logoColor=white",
    "firebase": "https://img.shields.io/badge/firebase-FFCA1D.svg?style=flat-square&logo=firebase&logoColor=black",
    "scss": "https://img.shields.io/badge/Sass-%23CC6699.svg?style=flat-square&logo=sass&logoColor=white",
    "auth0": "https://img.shields.io/badge/auth0-%230B0D17.svg?style=flat-square&logo=auth0&logoColor=white",
    "chrome extension": "https://img.shields.io/badge/Chrome_Extensions-%23F1502F.svg?style=flat-square&logo=google-chrome&logoColor=white",
    "flutter": "https://img.shields.io/badge/Flutter-%2302569B.svg?style=flat-square&logo=Flutter&logoColor=white",
    "dart": "https://img.shields.io/badge/Dart-%230175C2.svg?style=flat-square&logo=dart&logoColor=white",
    "firebase authentication": "https://img.shields.io/badge/firebase_auth-%23039BE5.svg?style=flat-square&logo=firebase&logoColor=white",
    "firestore": "https://img.shields.io/badge/Cloud_Firestore-DD2C00.svg?style=flat-square&logo=firebase&logoColor=white",
    "react native": "https://img.shields.io/badge/React_Native-%2320232a.svg?style=flat-square&logo=react&logoColor=%2361DAFB",
    "expo": "https://img.shields.io/badge/Expo-%23000020.svg?style=flat-square&logo=expo&logoColor=white",
    "webpack": "https://img.shields.io/badge/Webpack-%238DD6F9.svg?style=flat-square&logo=webpack&logoColor=black",
    "python": "https://img.shields.io/badge/Python-FFCA1D.svg?style=flat-square&logo=python&logoColor=black",
    "pandas": "https://img.shields.io/badge/Pandas-%2314354C.svg?style=flat-square&logo=pandas&logoColor=white",
    "django": "https://img.shields.io/badge/Django-%23092E20.svg?style=flat-square&logo=django&logoColor=white",
    "codeforces api": "https://img.shields.io/badge/Codeforces-%23F34428.svg?style=flat-square&logo=Codeforces&logoColor=white",
    "java": "https://img.shields.io/badge/Java-%23ED8B00.svg?style=flat-square&logo=java&logoColor=white",
    "opencv": "https://img.shields.io/badge/OpenCV-%23white.svg?style=flat-square&logo=OpenCV&logoColor=white",
    "tkinter": "https://img.shields.io/badge/tkinter-%23white.svg?style=flat-square&logo=python&logoColor=white",
    "material ui": "https://img.shields.io/badge/Material--UI-0081CB?style=flat-square&material-ui&logoColor=white",
    "typescript": "https://img.shields.io/badge/TypeScript-%23007ACC.svg?style=flat-square&logo=typescript&logoColor=white",
    "vscode": "https://img.shields.io/badge/Visual_Studio_Code-007ACC?style=flat-square&logo=visual-studio-code&logoColor=white",
    "markdown": "https://img.shields.io/badge/markdown-%23000000.svg?style=flat-square&logo=markdown&logoColor=white",
    "css": "https://img.shields.io/badge/CSS-239120?style=flat-square&logo=css3&logoColor=white",
    "vscode extension": "https://img.shields.io/badge/VS_Code_Extension-007ACC?style=flat-square&logo=visual-studio-code&logoColor=white",
    "selenium": "https://img.shields.io/badge/Selenium-239120.svg?style=flat-square&logo=selenium&logoColor=white",
    "robot": "https://img.shields.io/badge/Robot%20Framework-00C0B5.svg?style=flat-square&logo=robotframework&logoColor=white",
}